module.exports = __webpack_public_path__ + "static/media/its_catching.a6340de8.png";